import SendIcono from "../../../assets/svg/SendIcono.svg";
import IconoCheck from "../../../assets/svg/IconoCheck.svg";
import DoubleCheck from "../../../assets/svg/DoubleCheck.svg";
import LineGray from "../../../assets/svg/LineEstatusPayRollIncident.svg";
import LineGreen from "../../../assets/svg/LineGreen.svg";
import LineGreenAutoriza from "../../../assets/svg/LineGreenAutoriza.svg";
import CircleGray from "../../../assets/svg/CircleGray.svg";

const EstatusLine = ({row}:any) => {
  const {ApprovedDirect,ApprovedRH}=row
  console.log(row)
   return (
    <div className='conatinerEstatusPayRollIncident'>
      <div className='containerTitleEstatusPayRollIncident'>
      {(!ApprovedDirect && !ApprovedRH) ?
        `Enviada`:
        (ApprovedDirect && !ApprovedRH) ?
        `Aprobada`:
        (ApprovedDirect && ApprovedRH) ?
        `Autorizada`: ''
      }  
      </div>    
      <div className='containerIconsEstatusPayRollIncident'>
       {(!ApprovedDirect && !ApprovedRH) ?
        <>
           <img  src={SendIcono} alt=""></img>
           <img  src={LineGray} alt=""></img>
           <img  src={CircleGray} alt=""></img>
           <img  src={LineGray} alt=""></img>
           <img  src={CircleGray} alt=""></img>
        </>   
        :(ApprovedDirect && !ApprovedRH) ?
         <>
           <img  src={SendIcono} alt=""></img> 
           <img  src={LineGreen} alt=""></img> 
           <img  src={IconoCheck} alt=""></img>
           <img  src={LineGray} alt=""></img>
           <img  src={CircleGray} alt=""></img>
         </>
        : (ApprovedDirect && ApprovedRH) ? 
        <><img  src={SendIcono} alt=""></img>
          <img  src={LineGreen} alt=""></img> 
          <img  src={IconoCheck} alt=""></img> 
          <img  src={LineGreenAutoriza} alt=""></img> 
          <img  src={DoubleCheck} alt=""></img></>        
        :''
       }
      </div>    
    
    </div>    
    
  )
}

export default EstatusLine